module.exports = __webpack_public_path__ + "static/img/diy-backup.ab65bc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/reformat/diy-backup.png
// module id = MoFL
// module chunks = 0